import React from 'react'
import css from './Feelings.css'
import { i18n } from '../../index'
import type { SingleWeekFeelingReport } from './feelingReportTypes'
import RestrictedView from '../../auth/RestrictedView'
type TableWeekRowProps = {
  data: SingleWeekFeelingReport
}

const WeekRow = ({ data }: TableWeekRowProps) => (
  <React.Fragment>
    <tr className={css.weekSummaryRow}>
      <td>
        <span>{`${i18n.t('common.weekShort')} ${data.week}`}</span>
      </td>
      <td>{data.weekAverage}</td>
      <td>{`${data.weeklyFeelingMeters}/${data.weeklyEmployees}`}</td>
      <td>{data.weeklyFeedbacks}</td>
      <RestrictedView requiredPermission='view_feedback'>
        <td />
      </RestrictedView>
    </tr>
  </React.Fragment>
)

export default WeekRow
